import { render, staticRenderFns } from "./SysnoticeList.vue?vue&type=template&id=4a5966fa&scoped=true"
import script from "./SysnoticeList.vue?vue&type=script&lang=js"
export * from "./SysnoticeList.vue?vue&type=script&lang=js"
import style0 from "./SysnoticeList.vue?vue&type=style&index=0&id=4a5966fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5966fa",
  null
  
)

export default component.exports